export default __webpack_public_path__ + "static/media/magick-home.e331a738.png";